import { supabase } from '@/integrations/supabase/client';
import { useCartStore } from '@/stores/cartStore';
import { measurementAllowed } from '@/lib/editorialAttribution';

export type NoticePlacement = 'cart' | 'drawer' | 'mobile_cart';
// Keep writes ordered so a checkout click cannot overtake an acknowledgment.
let writes: Promise<unknown> = Promise.resolve();
export function recordCheckoutNotice(placement: NoticePlacement, acknowledged = false) {
  const cartId = useCartStore.getState().cartId;
  if (!cartId || !measurementAllowed()) return;
  writes = writes.catch(() => undefined).then(async () => {
    if (!measurementAllowed()) return;
    const { error } = await supabase.functions.invoke('checkout-reconciliation', {
      body: { action: 'notice', cartId, placement, acknowledged },
    });
    if (error) throw error;
  });
  void writes.catch(() => undefined);
}
export async function flushCheckoutNotice() {
  // Measurement must never prevent payment if its request stalls.
  await Promise.race([writes.catch(() => undefined), new Promise(resolve => setTimeout(resolve, 2500))]);
}